export default (value: number, numberOfDecimals: number): number => {
  if (numberOfDecimals < 0) {
    throw Error('Number of decimals must be greater or equal to 0');
  }
  const multiplier = 10 ** numberOfDecimals;
  return Math.round(value * multiplier) / multiplier;
};
